export default `
query {
  sections: sectionCollection(limit: 3) {
    items {
      sys {
        id
      }
      title
      subtitle
      bannerSubtitle
      uiText
      slug
      order
      description {
        json
      }
      image {
        sys {
          id
        }
        width
        height
        url
        description
      }
      largeImage {
        sys {
          id
        }
        width
        height
        url
        description
      }
    }
  }
  homeBanner: homeBannerCollection(limit: 1) {
    items {
      title
      description {
        json
      }
      image {
        sys {
          id
        }
        url
        width
        height
        contentType
        description
      }
      largeImage {
        sys {
          id
        }
        width
        height
        url
        contentType
        description
      }
    }
  }
  filters: filterCollection(limit: 30) {
    items {
      title
      slug
    }
  }
  heroesDetail: heroesDetailCollection(limit: 1) {
    items {
      description {
        json
      }
    }
  }
  heroes: heroCollection(limit: 100) {
    items {
      sys {
        id
      }
      slug
      firstName
      lastName
      role
      description {
        json
      }
      image {
        sys {
          id
        }
        width
        height
        url
        description
      }
      largeImage {
        sys {
          id
        }
        width
        height
        url
        description
      }
      filtersCollection(limit: 10) {
        items {
          title
          slug
        }
      }
    }
  }
  audioStories: audioStoryCollection(limit: 10) {
    items {
      sys {
        id
      }
      slug
      title
      image {
        sys {
          id
        }
        width
        height
        url
        description
      }
      largeImage {
        sys {
          id
        }
        width
        height
        url
        description
      }
      description {
        json
      }
      duration
      audiosCollection(limit: 5) {
        items {
          title
          language
          audio {
            sys {
              id
            }
            url
            title
            description
          }
          duration
          transcript {
            json
          }
          credits {
            json
          }
        }
      }
      order
      related {
        type: __typename
        sys {
          id
        }
      }
    }
  }
  essayItems: essayItemCollection(limit: 100) {
    items {
      sys {
        id
      }
      title
      image {
        sys {
          id
        }
        width
        height
        url
        description
      }
      largeImage {
        sys {
          id
        }
        width
        height
        url
        description
      }
      description {
        json
      }
    }
  }
  essays: essayCollection(limit: 10) {
    items {
      title
      subtitle
      description {
        json
      }
      sys {
        id
      }
      image {
        sys {
          id
        }
        width
        height
        url
        description
      }
      largeImage {
        sys {
          id
        }
        width
        height
        url
        description
      }
      coverImage {
        sys {
          id
        }
        width
        height
        url
        description
      }
      coverImageLarge {
        sys {
          id
        }
        width
        height
        url
        description
      }
      thumbnail {
        sys {
          id
        }
        width
        height
        url
        description
      }
      order
      essayItemsCollection(limit: 50) {
        items {
          sys {
            id
          }
        }
      }
    }
  }
  about: aboutCollection(limit: 10) {
    items {
      sys {
        id
      }
      title
      slug
      order
      content {
        json
        links {
          entries {
            block {
              ... on ContentBlock {
                sys {
                  id
                }
                title
                language
                content {
                  json
                }
              }
            }
          }
        }
      }
    }
  }
}
`
